// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__rjhlP","copy":"Footer_copy__voLVR"};